import { render } from "./DashBoard.vue?vue&type=template&id=1a4c2d36&scoped=true"
import script from "./DashBoard.vue?vue&type=script&lang=js"
export * from "./DashBoard.vue?vue&type=script&lang=js"

import "./DashBoard.vue?vue&type=style&index=0&id=1a4c2d36&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4c2d36"]])

export default __exports__